export default {
    props: ["name", "label", "active", "disabled"],
    data() {
        return {
            ces: this.$props.active
        }
    },
    methods: {
        updateCheck() {
            this.$emit('check', !this.ces)
        },
        updateCes() {
            this.updateCheck(this.ces)
        }
    },
    watch: {
        active: function (newVal) { // watch it
            this.ces = newVal
        }
    }
}